{
	"language": {
		"select": "언어 선택",
		"sectionTitle": "언어",
		"changeSuccess": "언어가 변경되었습니다"
	},
	"assistant": {
		"composer": {
			"placeholder": "{{assistantName}}에게 질문",
			"disclaimer": "{{assistantName}}는 실수를 할 수 있습니다. 중요한 정보는 꼭 확인하세요."
		},
		"greeting": {
			"initialMessage": "👋 안녕하세요, **{{assistantName}}** 학습 어시스턴트입니다. **{{context}}** 준비를 더 잘할 수 있도록 도와드릴게요. **{{topic}}**에 대해 답한 문항을 자세히 살펴봅시다.",
			"starter": "안녕하세요, **{{assistantName}}**입니다. 무엇을 도와드릴까요?"
		},
		"chips": {
			"askYourOwn": "직접 질문하기",
			"askFollowUp": "추가 질문하기"
		},
		"emptyState": {
			"title": "{{assistantName}}는 AI 학습 어시스턴트입니다",
			"contextSubtitle": "{{context}}에 대해 무엇이든 물어보세요",
			"activateSubtitle": "문항에 답하면 {{assistantName}}를 사용할 수 있습니다"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "빠른 학습",
			"examInfo": {
				"subtitle": {
					"setExamDate": "시험일 설정",
					"examDateWithValue": "시험일: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "아쉬워요",
				"itsAwesome": "훌륭해요"
			},
			"title": "순조롭게 나아가고 있어요!",
			"body": "꾸준히 학습하시는 모습이 정말 멋집니다! 지금까지 앱을 사용해 보신 경험은 어떠셨나요? 리뷰로 의견을 들려주시겠어요?",
			"cta": "나중에 하기"
		},
		"actions": {
			"studyWeak": "취약 영역 집중 학습",
			"viewProgress": "진행 상황 보기",
			"seeRank": "내 순위 확인",
			"seeRankings": "리더보드 보기",
			"unlock": "프리미엄 콘텐츠 잠금 해제",
			"unlockTooltip": "프리미엄 콘텐츠를 잠금 해제하면 전용 기능과 심화 학습 자료를 이용할 수 있습니다",
			"startCustomSession": "맞춤 세션 만들기",
			"startCustomSessionTooltip": "맞춤 학습 세션을 시작해 원하는 영역에 집중해 보세요",
			"takeDiagnostic": "진단 평가 응시",
			"takeDiagnosticTooltip": "진단 평가로 현재 실력을 파악하고 학습 계획을 맞춤 설정하세요",
			"viewDiagnostic": "진단 결과 보기",
			"viewDiagnosticTooltip": "진단 결과에서 강점과 개선이 필요한 영역을 확인하세요",
			"viewPodcasts": "팟캐스트 듣기",
			"viewPodcastsTooltip": "학습에 도움이 되는 교육 팟캐스트를 이용해 보세요",
			"upgradeToPremium": "프리미엄 시작하기",
			"upgradeToPremiumTooltip": "프리미엄으로 업그레이드하고 모든 콘텐츠와 기능을 이용하세요",
			"extendAccess": "이용 기간 연장",
			"extendAccessTooltip": "프리미엄 콘텐츠와 기능의 이용 기간을 연장하세요",
			"setExamDate": "시험일 설정",
			"setExamDateTooltip": "시험일을 설정하면 진행 상황을 추적하고 시험을 준비할 수 있습니다"
		},
		"exam": {
			"daysAgo_one": "{{count}}일 전",
			"daysAgo_other": "{{count}}일 전",
			"untilExam_one": "시험까지 {{count}}일",
			"untilExam_other": "시험까지 {{count}}일",
			"isToday": "오늘이 시험일입니다!"
		},
		"stats": {
			"mastery": "숙달도",
			"completed_one": "푼 문항",
			"completed_other": "푼 문항",
			"completedValue": "{{count}}",
			"xpEarned": "획득 XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "정답률",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "예상 {{skill, lowercase}} 숙련도는 {{level, lowercase}}입니다",
			"itemsAnsweredTooltip": "지금까지 푼 전체 문항 수입니다",
			"responsesAnsweredTooltip": "지금까지 제출한 전체 답안 수입니다",
			"examDateTooltip": "시험일은 {{date}}입니다",
			"skillCta": {
				"diagnostic": "진단",
				"practice": "연습하기"
			}
		},
		"menu": {
			"settings": "설정",
			"profile": "프로필"
		},
		"diagnostics": {
			"title": "진단 평가",
			"free": "무료",
			"duration": "{{count}} {{item}} • {{minutes}}분",
			"completed": "{{count}} {{item}} 완료",
			"start": "시작",
			"viewReport": "리포트 보기",
			"resume": "이어서 하기"
		},
		"practiceTests": {
			"title": "모의고사",
			"sectionalTestsTitle": "섹션별 테스트",
			"diagnosticAssessmentsTitle": "진단 평가",
			"premiumChipTooltip": "{{examName}} 시험을 위한 실전 길이의 프리미엄 모의고사입니다",
			"freeChipTooltip": "{{examName}} 시험을 위한 {{label}}",
			"freeChipTooltipDefault": "{{examName}} 시험을 위한 무료 진단 평가입니다",
			"completedDescription_one": "{{count}}문항 • {{date}}",
			"completedDescription_other": "{{count}}문항 • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}}문항 • {{timeRemaining}} 남음",
			"activeDescription_other": "{{attempted}}/{{count}}문항 • {{timeRemaining}} 남음",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}}문항 • {{timeRemaining}} 남음 • 시작일: {{startedOn}} • 종료일: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}}문항 • {{timeRemaining}} 남음 • 시작일: {{startedOn}} • 종료일: {{endsOn}}",
			"notStartedDescription_one": "{{count}}문항 • {{duration}}",
			"notStartedDescription_other": "{{count}}문항 • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}}문항 • {{duration}} • 종료일: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}}문항 • {{duration}} • 종료일: {{endsOn}}",
			"viewResultsCta": "결과 보기",
			"startCta": "시작",
			"chips": {
				"items_one": "{{count}}문항",
				"items_other": "{{count}}문항",
				"progress_one": "{{attempted}}/{{count}}문항",
				"progress_other": "{{attempted}}/{{count}}문항",
				"timeRemaining": "{{time}} 남음",
				"startedOn": "시작일: {{date}}",
				"endsOn": "종료일: {{date}}",
				"timeLeft": "{{time}} 남음"
			},
			"status": {
				"notStarted": {
					"label": "시작 전",
					"section": "실전 길이 모의고사"
				},
				"inProgress": {
					"label": "진행 중",
					"section": "진행 중"
				},
				"completed": {
					"label": "완료",
					"section": "완료"
				},
				"legacyReports": {
					"label": "이전 리포트",
					"section": "이전 리포트"
				},
				"migratedReports": {
					"label": "이전된 리포트",
					"section": "이전된 리포트"
				}
			}
		},
		"skills": {
			"title": "능력별 학습",
			"unlockSubtitle": "프리미엄을 잠금 해제하고 연습하세요",
			"startCta": "연습하기",
			"freeItemsIncludedChip": "무료 문항 포함",
			"freeItemsAnsweredSubtitle_one": "무료 문항 {{count, number}}개 중 {{answered, number}}개 완료",
			"freeItemsAnsweredSubtitle_other": "무료 문항 {{count, number}}개 중 {{answered, number}}개 완료",
			"progressCards": {
				"questionTypesTitle": "문제 유형별 성취도",
				"questionTypesSubtitle": "{{skill}} 문제 유형별 점수 현황입니다",
				"proficiencyTitle": "숙련도별 성취도",
				"proficiencySubtitle": "{{skill}} 수준별 진행 상황입니다",
				"questionTypeCardSubtitle": "숙련도별 진행 상황",
				"bySkillTitle": "능력별 성취도",
				"bySkillSubtitle": "전체 능력별 진행 상황",
				"needsImprovementTitle": "개선이 필요한 영역",
				"needsImprovementSubtitle": "다음으로 집중할 주제",
				"skillPerformanceTitle": "{{skill}} 성취도",
				"skillPerformanceSubtitle": "문제 유형 및 숙련도별 진행 상황",
				"skillLevelSubtitle": "이 능력 수준의 진행 상황입니다",
				"skillsPerformanceTitle": "능력별 성취도",
				"performanceByItemDifficulty": "문항 난이도별 성취도",
				"performanceByItemDifficultyCaption_one": "푼 문항 {{count}}개를 기준으로 숙련도별 정답률을 보여 줍니다",
				"performanceByItemDifficultyCaption_other": "푼 문항 {{count}}개를 기준으로 숙련도별 정답률을 보여 줍니다",
				"questionTypePartSubtitle": "{{skill}} · 파트 {{part}}",
				"activityGoalTitle": "활동 및 목표 진행 상황",
				"recentActivityTitle": "최근 활동",
				"goalProgressTitle": "목표 진행 상황",
				"goalProgressSubtitle": "종합 점수 · 최근 7주",
				"goalProgressInsight": "꾸준히 향상되고 있습니다. 목표까지 14점 남았으며 약 3주 후에 목표에 도달할 수 있습니다.",
				"goalProgressActualLabel": "내 점수",
				"goalProgressTargetLabel": "목표",
				"goalProgressTimeAxisLabel": "기간",
				"goalProgressScoreAxisLabel": "전체 진행 상황",
				"statusTitle": "내 현황",
				"diagnosticsTitle": "진단 평가",
				"diagnosticsReviewCta": "복습하기",
				"strengthsFocusTitle": "강점 및 집중 영역",
				"strengthsFocusSubtitle": "가장 강한 영역과 연습이 더 필요한 문제 유형입니다",
				"strengthsLabel": "강점",
				"focusAreasLabel": "집중 영역",
				"recommendedNextStepLabel": "추천 다음 단계",
				"recommendedNextStepCta": "시작",
				"practiceTestsViewMore": "모의고사 {{count}}개 모두 보기"
			},
			"proficiencySection": "숙련도별 연습"
		},
		"recommendedTasks": {
			"sectionTitle": "추천 학습",
			"startSessionAction": "연습하기",
			"resumeAction": "이어서 하기",
			"reviewResultsAction": "결과 확인",
			"startTestAction": "시험 시작",
			"activeTestBody": "진행 중인 평가를 마무리하세요",
			"completedTestBody": "성취도와 답안을 확인해 보세요",
			"diagnosticBody": "{{label}}에 응시해 시험 형식에 익숙해지세요",
			"diagnosticDefaultLabel": "무료 진단 평가",
			"practiceTestBody": "시간제 시험으로 시험 준비 상태를 점검하세요.",
			"sectionalTestBody": "{{skills}} 실력을 연습하는 집중 테스트를 응시하세요.",
			"weakSkillTitle": "{{skill}} 실력 키우기",
			"weakSkillBody": "{{questionType}} 연습. 아직 익히지 못한 부분에 집중합니다.",
			"strongSkillTitle": "{{skill}} 감각 유지하기",
			"strongSkillBody": "이 영역은 이미 탄탄합니다. 짧은 {{questionType}} 세트로 감각을 유지하세요.",
			"mixedSkillTitle": "{{skill}} 고르게 다지기",
			"mixedSkillBody": "{{questionTypes}}를 섞은 세트로, 놓친 부분에 집중합니다.",
			"higherDifficultySkillTitle": "{{proficiency}} 단계로 올라가기",
			"higherDifficultySkillBody": "이 수준의 {{questionType}}은 이미 숙달했습니다. 한 단계 더 어려운 문항입니다.",
			"itemsChip_one": "{{count}}문항",
			"itemsChip_other": "{{count}}문항",
			"timeRemainingChip": "{{minutes}}분 남음",
			"timeRemainingChipCompact": "{{minutes}}분"
		},
		"itemTypes": {
			"answeredLabel_one": "푼 문항",
			"answeredLabel_other": "푼 문항",
			"answeredAll": "전체",
			"answeredPartial": "{{total}}개 중 {{answered}}개",
			"cardSubtitleComplete": "모든 문항 완료",
			"cardSubtitlePartial": "{{total}}문항 중 {{attempted}}문항 완료",
			"cardSubtitleResponses_one": "답안 {{count}}개",
			"cardSubtitleResponses_other": "답안 {{count}}개",
			"responsesLabel_one": "답안",
			"responsesLabel_other": "답안",
			"detail": {
				"skillLabel": "능력",
				"estimatedLevelLabel": "예상 수준"
			}
		},
		"tagSections": {
			"summary": "{{label, lowercase}} {{tagCount, number}}개 • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{label, lowercase}} {{tagCount, number}}개",
			"responseCount_one": "답안 {{count, number}}개",
			"responseCount_other": "답안 {{count, number}}개"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "연습 문항 {{count, number}}개 무료 제공",
			"freeContentBannerTitle_other": "연습 문항 {{count, number}}개 무료 제공",
			"freeContentBannerBody": "선별된 {{skills}} 문항을 언제든 연습해 보세요. 업그레이드하면 전체 스터디 팩을 이용할 수 있습니다.",
			"freeContentBannerCta": "무료 연습 시작",
			"freeSampleBanner": {
				"body_one": "{{categories}}에서 선별된 문항을 언제든 연습해 보세요. 업그레이드하면 {{count, number}}개의 문항을 추가로 이용할 수 있습니다.",
				"body_other": "{{categories}}에서 선별된 문항을 언제든 연습해 보세요. 업그레이드하면 {{count, number}}개의 문항을 추가로 이용할 수 있습니다.",
				"moreTags": "{{count, number}}개의 {{label}} 더보기",
				"cta": "업그레이드"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "다른 학습자와 비교해 내 위치를 확인하세요"
		},
		"home": {
			"title": "홈"
		},
		"podcasts": {
			"description": "전문가가 진행하는 정형외과 팟캐스트를 들어 보세요."
		},
		"more": {
			"title": "추가 설정"
		}
	},
	"emptyState": {
		"progress": {
			"title": "학습 기록 없음",
			"subtitle": "학습을 시작하면 진행 상황이 여기에 표시됩니다",
			"cta": "지금 학습하기"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "오류",
			"body": "세션을 만들지 못했습니다. 다시 시도해 주세요"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "고급",
			"highIntermediate": "중급",
			"intermediate": "중급",
			"basic": "기초",
			"none": "미응답",
			"high": "숙달함",
			"medium": "거의 다 왔어요",
			"low": "보완 필요"
		}
	},
	"leaderboard": {
		"you": "나입니다",
		"periods": {
			"all_time": "전체 기간",
			"month": "이번 달",
			"week": "이번 주"
		},
		"scope": {
			"global": "전체",
			"friends": "친구"
		},
		"friends": {
			"soon": "출시 예정",
			"comingSoonTitle": "친구 리더보드",
			"comingSoonBadge": "출시 예정",
			"comingSoonDescription": "친구와 진행 상황을 비교하고 누가 1등인지 확인해 보세요."
		},
		"error": {
			"title": "연결 오류",
			"description": "리더보드를 불러올 수 없습니다. 연결 상태를 확인한 후 다시 시도해 주세요.",
			"tryAgain": "다시 시도"
		},
		"empty": {
			"title": "아직 순위가 없습니다",
			"description": "더 많은 사람이 학습할수록 순위가 갱신됩니다. 가장 먼저 XP를 획득하고 1위를 차지해 보세요!",
			"startLearning": "지금 학습하기"
		},
		"topPerformers": "상위 학습자",
		"yourPosition": "내 순위",
		"rankings": "순위",
		"rankingsRange": "순위 • {{startRank}}–{{endRank}}위",
		"unranked": {
			"title": "XP를 획득하고 순위에 참여하세요!",
			"description": "학습 세션을 시작해 첫 점수를 획득하고 리더보드에 참여하세요.",
			"cta": "첫 세션 시작하기"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "나",
		"podium": {
			"first": "1위",
			"second": "2위",
			"third": "3위"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>면 {{rank}}위를 앞섭니다</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>차이로 3위권 진입</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "레슨",
			"statusFilter": {
				"all": "전체",
				"inProgress": "진행 중",
				"notStarted": "시작 전",
				"completed": "완료"
			},
			"card": {
				"openCta": "열기",
				"resumeCta": "이어하기",
				"viewResultsCta": "결과 보기",
				"duration_one": "{{count}}분",
				"duration_other": "{{count}}분"
			},
			"viewToggle": {
				"list": "목록 보기",
				"grid": "그리드 보기"
			},
			"empty": {
				"filteredTitle": "이 필터와 일치하는 레슨이 없습니다",
				"filteredSubtitle": "다른 상태 필터를 사용해 보세요",
				"filteredCta": "전체 보기",
				"noneTitle": "레슨을 찾을 수 없습니다",
				"noneSubtitle": "필터를 제거하거나 새로 검색해 보세요",
				"noneCta": "모두 재설정"
			}
		},
		"home": {
			"hero": {
				"greeting": "환영합니다, {{name}}님!",
				"greetingNoName": "환영합니다!"
			},
			"stats": {
				"modulesDone": "완료한 모듈",
				"dayStreak": "연속 일수",
				"minutesToday": "오늘 학습 분"
			},
			"suggested": {
				"title": "회원님을 위한 추천",
				"openModuleCta": "모듈 열기",
				"status": {
					"ready": "준비됨",
					"next": "다음"
				}
			},
			"all": {
				"title": "모든 레슨"
			},
			"emptyState": {
				"title": "아직 레슨이 없습니다",
				"subtitle": "새 레슨이 곧 추가될 예정입니다."
			},
			"card": {
				"duration_one": "{{count}}분",
				"duration_other": "{{count}}분"
			}
		},
		"overview": {
			"header": {
				"title": "개요"
			},
			"startCta": "학습 시작하기",
			"objectives": {
				"title": "학습 목표"
			}
		},
		"detail": {
			"takeQuizCta": "퀴즈 풀기",
			"progress": {
				"label": "모듈 진행률"
			},
			"activities": {
				"title": "활동",
				"completedCount": "{{total}}개 중 {{completed}}개 완료"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "진행률 인사이트"
			},
			"milestones": {
				"title": "모듈 마일스톤",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "읽음"
			},
			"readTime": "{{count}}분 분량",
			"sectionBadge": {
				"label": "섹션 {{number}}/{{total}}"
			},
			"upNext": {
				"title": "다음 학습"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "맞춤 학습 세션",
		"diagnostic": "진단 평가",
		"skill": "능력",
		"Proficiency": "숙련도",
		"Question Type": "문제 유형",
		"mastery": "숙달도",
		"sessionLength": "세션 길이",
		"itemsChip_one": "{{count}}문항",
		"itemsChip_other": "{{count}}문항",
		"durationEstimate": "{{minutes}}분",
		"durationRange": "{{min}}–{{max}}분",
		"noItemsTooltip": "현재 필터와 일치하는 문항이 없습니다",
		"setCount": "{{count}} {{type}}",
		"dismiss": "확인",
		"status": {
			"notAnswered": "미응답",
			"needsWork": "보완 필요"
		},
		"itemCount": "{{topics}}에서 {{count}}문항을 학습합니다",
		"start": "세션 시작",
		"configuringSession": "세션 구성 중",
		"fetchingContent": "콘텐츠 불러오는 중",
		"preparingMaterials": "학습 자료 준비 중",
		"almostThere": "거의 다 됐습니다",
		"startingSession": "세션 시작 중",
		"playIcon": "play-outline",
		"infoText": "**{{numItems}}**{{itemCount}}을(를) 학습합니다. 약 **{{timeString}}** 정도 걸립니다.",
		"customSummary": {
			"message": "{{topics}}에서 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})을 학습합니다.",
			"messageWithMastery": "{{topics}}에서 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})을 학습하며 {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}})에 집중합니다.",
			"messageAllMasteryLevels": "{{topics}}에서 모든 숙달도 수준에 걸쳐 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})을 학습합니다.",
			"itemCount_one": "{{count}}문항",
			"itemCount_other": "{{count}}문항",
			"masteryLevelCount_one": "숙달도 수준",
			"masteryLevelCount_other": "숙달도 수준",
			"allTopics": "전체 {{count}}개 주제",
			"more": "외 {{count}}개",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "빠른 학습",
			"recommended": "추천",
			"custom": "맞춤",
			"selectHelper": "세션을 눌러 선택한 다음 준비되면 시작하세요.",
			"emptyRecommended": "현재 이용할 수 있는 추천 세션이 없습니다.",
			"summary": "{{skill}}에서 {{count}}문항을 학습합니다. 예상 소요 시간은 {{minutes}}분입니다.",
			"summary_questionType": "{{skill}}의 {{questionType}}에서 {{count}}문항을 학습합니다. 예상 소요 시간은 {{minutes}}분입니다.",
			"duration": "{{minutes}}분",
			"levelSessions": {
				"rapidRecall": "빠른 리콜",
				"purposefulPractice": "목표 집중 연습",
				"focusFlow": "집중 몰입",
				"itemsLabel": "{{level}} 문항",
				"itemsLabelGeneric": "문항",
				"summaries": {
					"rapidRecall": "아직 풀지 않은 {{level}} 문항 {{count}}개를 빠르게 훑으며 학습 범위를 꾸준히 넓혀 보세요. 예상 소요 시간은 {{minutes}}분입니다.",
					"purposefulPractice": "가장 보완이 필요한 내용부터 시작해 균형 있게 구성된 {{level}} 문항 {{count}}개를 풀어 보세요. 예상 소요 시간은 {{minutes}}분입니다.",
					"focusFlow": "숙달도가 낮거나 보통인 {{level}} 문항 {{count}}개로 취약한 부분을 보완하세요. 예상 소요 시간은 {{minutes}}분입니다."
				},
				"summariesGeneric": {
					"rapidRecall": "아직 풀지 않은 문항 {{count}}개를 빠르게 훑으며 학습 범위를 꾸준히 넓혀 보세요. 예상 소요 시간은 {{minutes}}분입니다.",
					"purposefulPractice": "가장 보완이 필요한 내용부터 시작해 균형 있게 구성된 문항 {{count}}개를 풀어 보세요. 예상 소요 시간은 {{minutes}}분입니다.",
					"focusFlow": "숙달도가 낮거나 보통인 문항 {{count}}개로 취약한 부분을 보완하세요. 예상 소요 시간은 {{minutes}}분입니다."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium",
			"durationSelector": {
				"title": "소요 시간"
			}
		}
	},
	"skillDetail": {
		"diagnosticInsight": "학습 경험을 맞춤화하려면 진단 퀴즈부터 시작하세요. 진단 결과는 학습 계획을 만드는 데 사용됩니다."
	},
	"premium": {
		"chip": "프리미엄",
		"upgrade": "프리미엄으로 업그레이드",
		"unlockTitle": "{{productName}}의 모든 기능을 잠금 해제하세요",
		"unlockDescription": "남은 학습 기간에 맞춰 설계된 맞춤 연습을 이용해 보세요.",
		"readyTitle": "{{date}} 시험을 완벽하게 준비하세요",
		"tip": "프리미엄은 나에게 꼭 맞는 학습 방향을 제시합니다. 다음에 무엇을 연습해야 할지 짚어 주고, 실력이 향상되면 학습 계획도 함께 조정됩니다."
	},
	"purchase": {
		"success": {
			"headerTitle": "구매해 주셔서 감사합니다!",
			"accessGranted": "{{name}} 이용 권한이 정상적으로 부여되었습니다",
			"studyPack": "스터디 팩",
			"practiceTest": "모의고사",
			"combo": "콤보",
			"documentTitle": "구매",
			"summary_one": "축하합니다! 아래 **상품**이 계정에 등록되었습니다. {{action}} 버튼을 누르면 앱의 컨텍스트가 **{{examName}}** 시험에 맞게 변경됩니다. 다른 시험을 준비하거나 다른 상품을 구매하려는 경우 계정 설정에서 언제든지 변경할 수 있습니다.",
			"summary_other": "축하합니다! 아래 **상품 {{count}}개**가 계정에 등록되었습니다. {{action}} 버튼을 누르면 앱의 컨텍스트가 **{{examName}}** 시험에 맞게 변경됩니다. 다른 시험을 준비하거나 다른 상품을 구매하려는 경우 계정 설정에서 언제든지 변경할 수 있습니다.",
			"unlockedDuration": "축하합니다! **{{name}}**에 대한 **{{duration}}** 이용 권한이 열렸습니다. **{{expiry}}**에 만료됩니다.",
			"storeNote": "참고: 스터디 팩은 모바일 앱에서만 이용할 수 있습니다. 사용 중인 기기에 맞는 앱을 다운로드하세요.",
			"actions": {
				"goToHome": "홈으로 이동",
				"startDiagnostic": "{{label}} 시작",
				"takeDiagnostic": "{{label}} 응시",
				"takeFreeDiagnostic": "무료 진단 평가 응시",
				"diagnosticLabel": "진단 평가"
			}
		},
		"checkout": {
			"headerTitle": "구매 완료하기"
		},
		"paywall": {
			"studyPackDialogTitle": "학습 플랜 업그레이드",
			"defaultDialogTitle": "학습 플랜 업그레이드",
			"practiceTestDialogTitle": "모의고사 잠금 해제",
			"restorePurchaseDialogTitle": "이미 구매하셨나요?",
			"restorePurchaseDialogSubheadingWeb": "아니라면 다음을 확인해 보세요:",
			"restorePurchaseDialogBody": "이미 이 상품을 구매하셨는데도 잠겨 있다면 다음을 확인해 주세요:\n\n1. 올바른 계정으로 로그인했는지 확인하세요\n2. 올바른 상품을 선택했는지 확인하세요\n3. 구독이 만료되지 않았는지 확인하세요\n4. 구독을 활성화했는지 확인하세요(스팸함도 확인해 주세요)\n5. 액세스 코드가 있다면 [액세스 코드]({{baseUrl}}/redeem)를 사용하세요\n\n해당 사항이 없다면 **여기를 클릭**해 주세요",
			"restorePurchaseDialogBodyWeb": "1. 올바른 이메일로 로그인했는지 확인하세요\n2. 올바른 **[시험이 선택](/account/settings)**되어 있는지 확인하세요\n3. 구독이 만료되지 않았는지 확인하세요\n\n해당 사항이 없다면 **고객 지원팀에 문의**해 주세요",
			"accesDuration": {
				"yearPlan": "**{{duration}}** 플랜은 이용 기간이 길어 자신의 속도에 맞춰 학습하고 시험을 충분히 준비할 수 있습니다.",
				"moreTime": "학습에 시간이 더 필요할 것 같다면 **{{duration}}** 플랜을 고려해 보세요.",
				"otherPlan": "**{{duration}}** 플랜은 **{{expiryText}}**까지 이용할 수 있어 학습하기에 충분한 시간을 제공합니다. {{moreTime}}"
			},
			"actions": {
				"upgrade": "업그레이드",
				"unlock": "{{price}}에 잠금 해제",
				"subscribe": "{{price}}에 구독",
				"extendAccess": "이용 기간 연장",
				"accessHere": "여기서 이용하기",
				"redeemAccessCode": "액세스 코드가 있으신가요?",
				"restorePurchase": "이미 구매하셨나요?",
				"restorePurchaseWeb": "이미 구매했거나 액세스 코드가 있으신가요?"
			},
			"subscriptionSummary": {
				"yearly": "연간 구독 • 자동 갱신 • 언제든 해지 가능",
				"monthly": "월간 구독 • 자동 갱신 • 언제든 해지 가능",
				"weekly": "주간 구독 • 자동 갱신 • 언제든 해지 가능",
				"generic": "자동 갱신 구독 • 언제든 해지 가능"
			},
			"planDuration": {
				"day_one": "{{count}}일",
				"day_other": "{{count}}일",
				"week_one": "{{count}}주",
				"week_other": "{{count}}주",
				"month_one": "{{count}}개월",
				"month_other": "{{count}}개월",
				"year_one": "{{count}}년",
				"year_other": "{{count}}년"
			},
			"recommendedPlan": {
				"plan": "**{{date}}** 시험을 가장 잘 준비할 수 있도록 \"**{{duration}}**\" 플랜을 추천합니다",
				"subscription": {
					"yearly": "**{{date}}** 시험을 꾸준히 준비할 수 있도록 **연간 구독**을 추천합니다",
					"monthly": "**{{date}}** 시험을 꾸준히 준비할 수 있도록 **월간 구독**을 추천합니다",
					"weekly": "**{{date}}** 시험을 꾸준히 준비할 수 있도록 **주간 구독**을 추천합니다",
					"generic": "**{{date}}** 시험을 꾸준히 준비할 수 있도록 **구독**을 추천합니다"
				}
			},
			"disclaimer": "구매를 확정하면 선택한 기간 동안 이 상품의 모든 콘텐츠를 이용할 수 있습니다. 기간이 만료되면 제한된 콘텐츠에 더 이상 접근할 수 없습니다. 시험일 변경 등의 이유로 이용 기간을 연장하고 싶다면 인앱 구매를 통해 기간을 추가할 수 있습니다. 자세한 내용은 [서비스 약관 및 개인정보 처리방침](https://memorang.com/legal)을 참고하세요."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}}개 {{type}}에서 푼 {{numItems}} {{item}} 기준",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "{{count}}개 {{type}}에 대한 진행 상황입니다. 지금까지 푼 {{itemCount}} {{item}}을 기준으로 합니다."
		},
		"needsImprovement": {
			"title": "개선이 필요한 영역",
			"subtitle": "보완하기 좋은 추천 {{type}}",
			"cta": "지금 학습하기"
		},
		"mastery": {
			"high": "숙달함",
			"medium": "거의 다 왔어요",
			"low": "보완 필요",
			"count": "{{count}} {{item}} 완료",
			"zeroTooltip": "푼 문항 {{total}}개 중 아직 {{label}} 항목이 없습니다",
			"highTooltip": "푼 {{total}} {{item}} 중 {{count}}개를 숙달했습니다",
			"mediumTooltip": "푼 {{total}} {{item}} 중 {{count}}개에서 진전을 보이고 있습니다",
			"lowTooltip": "푼 {{total}} {{item}} 중 {{count}}개는 연습이 더 필요합니다"
		},
		"stats": {
			"completion": "완료율",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "{{total}} {{item}} 중 {{completed}}개를 완료했습니다"
		},
		"exams": {
			"title": "모의고사",
			"subtitle_one": "완료한 평가 {{count}}개 기준",
			"subtitle_other": "완료한 평가 {{count}}개 기준"
		},
		"summary": {
			"title": "학습 요약",
			"subtitle": "푼 {{count}} {{item}} 기준",
			"tooltip": "전체 {{count}} {{item}}에 대한 숙달도와 완료 진행 상황을 보여 줍니다. 성취도는 연습 세션, 평가, 학습 활동을 통해 측정됩니다.",
			"mastery": "숙달도",
			"quickStats": "간단 통계"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}} 숙련도",
			"proficiencyCardTooltip": "현재 {{skill, lowercase}} 실력은 {{level, lowercase}} 수준입니다",
			"itemTypesCardSubtitle_one": "문제 유형 {{count}}개",
			"itemTypesCardSubtitle_other": "문제 유형 {{count}}개",
			"itemTypesCardTitle": "{{skill}} 문항",
			"itemTypeLevelTooltip": "“{{itemType}}” 문제 유형에서 현재 {{skill, lowercase}} 실력은 {{level, lowercase}} 수준입니다",
			"itemTypesFallbackTitle": "문항 유형",
			"itemTypesEmptyTitle": "문항 유형을 불러올 수 없음",
			"itemTypesEmptySubtitle": "이 능력에 해당하는 문항 유형을 찾지 못했습니다. 진행 상황으로 돌아가 다시 시도해 주세요.",
			"itemTypesEmptyCta": "진행 상황으로 돌아가기",
			"notAnswered": "미응답",
			"answeredSubtitle_one": "푼 문항 {{count}}개 기준",
			"answeredSubtitle_other": "푼 문항 {{count}}개 기준",
			"responsesSubtitle_one": "답안 {{count}}개 기준",
			"responsesSubtitle_other": "답안 {{count}}개 기준",
			"testsTakenSubtitle_one": "응시한 시험 {{count}}회 기준",
			"testsTakenSubtitle_other": "응시한 시험 {{count}}회 기준",
			"startFirstTest": {
				"title": "시작해 볼까요",
				"itemsSubtitle_one": "{{count}}문항",
				"itemsSubtitle_other": "{{count}}문항",
				"guidance": {
					"diagnostic": "먼저 진단 평가로 강점을 파악하고 학습 계획을 맞춰 보세요.",
					"sectional": "영역별 시험은 시험의 한 부분에만 집중하므로 더 짧은 시간에 점수를 확인할 수 있습니다.",
					"fullMock": "실전 모의고사는 실제 시험을 처음부터 끝까지 그대로 재현해 가장 완전한 점수를 제공합니다."
				}
			},
			"noScoresTitle": "아직 {{skill, lowercase}} 점수가 없습니다",
			"noScoresSubtitle": "첫 시험에 응시하고 예상 점수와 과제 세부 내역을 확인해 보세요.",
			"noScoresCta": "시작",
			"noScoresCardSubtitle": "응시하는 시험 기준",
			"personalBestLabel": "개인 최고 기록",
			"latestLabel": "최근 기록",
			"examCountdown_one": "시험까지 {{count}}일 남았습니다",
			"examCountdown_other": "시험까지 {{count}}일 남았습니다",
			"greeting": {
				"none": "{{firstName}}님, 시작해 볼까요! 🚀",
				"low": "{{firstName}}님, 좋은 출발이에요. 계속해 봐요! 💪",
				"medium": "{{firstName}}님, 이대로 계속해요! 💪",
				"high": "{{firstName}}님, 거의 다 왔어요! 🎯"
			},
			"greetingNoName": {
				"none": "시작해 볼까요! 🚀",
				"low": "좋은 출발이에요. 계속해 봐요! 💪",
				"medium": "이대로 계속해요! 💪",
				"high": "거의 다 왔어요! 🎯"
			},
			"stats": {
				"untilExam": "시험일",
				"itemsAnswered": "푼 문항",
				"responsesAnswered": "답안"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "패스코드가 올바르지 않습니다",
		"incorrectPassword": "비밀번호가 올바르지 않습니다. 다시 시도해 주세요.",
		"passwordPlaceholder": "비밀번호 입력",
		"emailPlaceholder": "예: dave@gmail.com",
		"verify": {
			"openEmail": "이메일을 열어 계속하기",
			"signInCta": "계정을 확인하는 중...",
			"signUpCta": "계정을 만드는 중...",
			"contactSupport": "이메일이 보이지 않나요? 스팸함을 확인하거나",
			"contactSupportLink": "문의하기",
			"resendMagicLink": "매직 링크 다시 보내기",
			"resendMagicLinkIn": "{{time}} 후 매직 링크 다시 보내기",
			"signInBody": "거의 다 됐습니다! {{appName}} 앱에 안전하게 로그인할 수 있도록 정보를 확인하고 있습니다.",
			"signUpBody": "거의 다 됐습니다! 새 {{appName}} 앱 계정을 만들기 위해 정보를 확인하고 있습니다.",
			"magicLinkEmail": "**{{email}}**(으)로 매직 링크를 보냈습니다\n이메일의 링크를 클릭해 안전하게 로그인하세요.",
			"magicLinkEmailExpiry": "이 링크는 10분 후 만료됩니다",
			"confirmEmail": "이메일 확인",
			"redirectingToApp": "{{appName}} 앱으로 이동하는 중...",
			"appNotOpen": "앱이 열리지 않았나요? 아래 버튼을 눌러 해당 앱을 실행하세요",
			"openApp": "{{appName}} 앱 열기",
			"installAppPrompt": "아무 반응이 없다면 기기에 {{appName}} 앱이 설치되어 있는지 확인해 주세요",
			"verifyAccountTitle": "계정 확인",
			"emailResent": "{{email}}(으)로 매직 링크를 보냈습니다\n받은 편지함과 스팸함을 확인해 주세요.",
			"verificationLinkExpired": "인증 링크 만료됨",
			"verificationLinkExpiredBody": "인증 링크는 10분 후 만료되며 한 번만 사용할 수 있습니다. \n다시 로그인해 새 링크를 요청할 수 있습니다",
			"accountSetupTimeoutTitle": "로그인을 완료할 수 없음",
			"accountSetupTimeoutBody": "계정 설정이 예상보다 오래 걸리고 있습니다. 다시 로그인해 보시고, 문제가 계속되면 고객 지원팀에 문의해 주세요.",
			"loginAgain": "다시 로그인",
			"contactSupportExpiredLink": "이 문제가 계속 발생한다면 알려 주세요",
			"successTitle": "다른 탭에서 로그인되었습니다",
			"successBody": "이 탭을 닫거나 여기서 계속 진행하세요",
			"successCtaLabel": "여기서 계속하기",
			"needHelpLabel": "도움이 필요하신가요?",
			"contactSupportButton": "고객 지원 문의"
		},
		"contactSupportDialog": {
			"title": "로그인에 문제가 있나요?",
			"body": "로그인에 문제가 있다면 고객 지원팀에 문의하시거나 다시 시도해 주세요",
			"cta": "이메일 보내기"
		},
		"emailInstruction": {
			"default": "이메일이 오지 않으면 정크, 스팸, 최근 삭제된 항목 폴더를 확인해 주세요",
			"edu": "이메일이 오지 않으면 정크, 스팸, 최근 삭제된 항목 폴더를 확인하거나 IT 관리자에게 문의해 주세요"
		},
		"createSessionLoader": {
			"configuringSession": "세션 구성 중",
			"analyzingMastery": "숙달도 분석 중",
			"loadingContent": "콘텐츠 불러오는 중"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "어떻게 불러 드릴까요?",
				"description": "사용자 이름은 공개 리더보드에 표시되며, 실명은 비공개로 유지됩니다.",
				"usernameLabel": "사용자 이름",
				"firstNameLabel": "이름",
				"lastNameLabel": "성",
				"avatarLabel": "아바타",
				"avatarTooltip": "아바타는 사용자 이름을 바탕으로 자동 생성됩니다.",
				"profileSaveFailed": "프로필을 저장하지 못했습니다. 다시 시도해 주세요."
			},
			"testDate": {
				"cta": "계속"
			},
			"examDate": {
				"daysAway": "{{value}}일이 남았습니다. 가장 취약한 영역부터 바로 집중해 드릴게요."
			},
			"skills": {
				"chooseAll": "해당하는 항목을 모두 선택하세요"
			},
			"plan": {
				"recommended": "추천"
			},
			"toeicLevelOverview": {
				"title": "누구나 시작점은 있습니다.",
				"description": "연습을 통해 한 단계에서 실력을 다지면 자연스럽게 다음 단계로 나아가게 됩니다.",
				"illustrationLabel": "기초(A1–A2)에서 중급(B1–B2), 그리고 능숙(C1)으로 이어지는 단계입니다.",
				"levels": {
					"basic": {
						"name": "기초",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "중급",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "능숙",
						"band": "C1"
					}
				},
				"progression": {
					"title": "앞으로의 성장 과정",
					"practiceSessions": "추천 세션으로 연습하기",
					"buildMastery": "현재 수준에서 실력 다지기",
					"growToward": "능숙 단계를 향해 계속 성장하기"
				},
				"levelDetails": {
					"title": "각 단계의 의미",
					"scoreRange": "{{band}} · 점수 {{min}}–{{max}}",
					"basic": {
						"name": "기초 사용자",
						"summary": "간단한 업무 영어",
						"examples": {
							"forms": "양식 및 공지문",
							"instructions": "안내문",
							"announcements": "짧은 안내 방송"
						}
					},
					"intermediate": {
						"name": "중급 사용자",
						"summary": "일상적인 업무 커뮤니케이션",
						"examples": {
							"emails": "이메일 및 대화",
							"customers": "고객 응대",
							"followUps": "회의 후속 업무"
						}
					},
					"proficient": {
						"name": "능숙 사용자",
						"summary": "전문적이고 수준 높은 영어",
						"examples": {
							"reports": "복잡한 보고서 및 프레젠테이션",
							"negotiations": "미묘한 뉘앙스의 협상",
							"highStakes": "중요도가 높은 업무 상황"
						}
					}
				},
				"disclaimer": "TOEIC Link 점수는 CEFR에 맞춘 가이드라인이며 절대적인 합격 기준점은 아닙니다. 읽기와 듣기는 각각 독립적으로 향상되므로 능력별로 도달 수준이 다를 수 있습니다."
			},
			"review": {
				"diagnosticChoice": {
					"title": "진단 평가: {{title}}",
					"body": "집중할 영역을 찾기 위한 {{count}}문항",
					"duration": "{{minutes}}분"
				},
				"homeChoice": {
					"title": "직접 둘러보기",
					"body": "아직 시작할 준비가 안 됐어요. 앱을 먼저 살펴볼게요"
				}
			}
		},
		"common": {
			"changeLater": "나중에 변경할 수 있습니다"
		},
		"actions": {
			"previous": "이전",
			"finish": "완료",
			"start": "시작",
			"continue": "계속",
			"stepIndicator": "{{total}}단계 중 {{step}}단계"
		}
	},
	"more": {
		"profile": {
			"title": "내 정보"
		},
		"exam": {
			"title": "내 시험"
		},
		"subscriptions": {
			"title": "상품",
			"redeem": {
				"title": "구매 등록"
			},
			"extend": {
				"cta": "연장"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "목표 시험일 설정",
			"description": "이 날짜는 앱 내 학습 일정을 안내하는 용도로만 사용되며, 실제 시험 접수에는 영향을 주지 않습니다.",
			"dismissCta": "나중에",
			"confirmCta": "시험일 설정"
		}
	},
	"account": {
		"title": "계정 설정",
		"currentExam": "현재 시험",
		"subscriptions": "상품",
		"examDate": "시험일",
		"examDateUpdated": "시험일이 {{date}}(으)로 설정되었습니다",
		"selectDate": "날짜 선택",
		"appearance": "화면 설정",
		"features": "기능",
		"audioPlaybackTest": "오디오 재생 테스트 대화상자 표시",
		"theme": "테마",
		"selectTheme": "테마 선택",
		"themeOptions": {
			"system": "시스템 설정",
			"light": "라이트",
			"dark": "다크"
		},
		"accountInfo": "계정",
		"username": "사용자 이름",
		"name": "이름",
		"nameNotSet": "설정되지 않음",
		"save": "저장",
		"editUsername": {
			"title": "사용자 이름 수정"
		},
		"editName": {
			"title": "이름 수정"
		},
		"email": "이메일",
		"dev": "개발",
		"sandbox": "샌드박스",
		"redoOnboarding": "온보딩 다시 하기",
		"about": "정보",
		"termsOfService": "서비스 약관",
		"privacyPolicy": "개인정보 처리방침",
		"aiToolsTos": "AI 도구 이용약관",
		"support": "고객 지원",
		"supportEmailBody": "[  ]에 대한 도움이 필요해 문의드립니다\n\n\n\n문제를 더 빠르게 해결하는 데 도움이 되는 정보입니다: \n\n계정에 연결된 사용자 이름(앱에 로그인한 후 설정에서 확인 가능):\n{{username}}\n\n주문에 사용한 이메일(앱에 로그인한 후 설정에서 확인 가능):\n{{email}}\n\n주문 번호(보통 구매 시 발송된 영수증 이메일에서 확인 가능):\n\n실제 구매 시 다른 이름이나 이메일을 사용했을 가능성이 있나요? 그렇다면 알려 주세요:\n\n이름:\n\n이메일:",
		"contactSupport": "고객 지원 문의",
		"signOut": "로그아웃",
		"signOutConfirmation": "로그아웃하시겠습니까?",
		"deleteAccount": "계정 삭제",
		"platform": "플랫폼",
		"partnerships": "제휴",
		"validUntil": "{{date}}에 만료",
		"extendValidity": "이용 기간 연장",
		"redeemPurchase": "구매 등록",
		"redeemPurchaseNoneFound": "등록할 수 있는 구매 내역이 없습니다",
		"redeemPurchaseCheckFailed": "구매 내역을 확인하지 못했습니다. 다시 시도해 주세요.",
		"purchases": "구매",
		"frequentlyAskedQuestions": "자주 묻는 질문",
		"deleteFeedbackForm": {
			"placeholder": "의견"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "데이터가 더 필요합니다",
		"proficiencyLevelPendingTooltip": "{{label}} 문항을 더 풀면 수준을 추정할 수 있습니다",
		"on": "에",
		"gotIt": "확인",
		"goBack": "돌아가기",
		"topic": "주제",
		"itemCount_one": "{{count, number}}문항",
		"itemCount_other": "{{count, number}}문항",
		"examCount_one": "시험 {{count}}개",
		"examCount_other": "시험 {{count}}개",
		"questionCount_one": "문제 {{count}}개",
		"questionCount_other": "문제 {{count}}개",
		"item_one": "문항",
		"item_other": "문항",
		"and": "및",
		"this": "이",
		"of": "중",
		"knowMore": "자세히 알아보기",
		"proficiency": "숙련도",
		"didNotAnswer": "아직 풀지 않은 문항",
		"notAnswered": "미응답",
		"attempted": "시도함",
		"attempt": "시도",
		"activity": "활동",
		"performance": "성취도",
		"estimatedProficiency": "예상 숙련도",
		"details": "세부 정보",
		"keepPracticing": "계속 연습해 보세요!",
		"leaveFeedback": "의견 보내기",
		"copiedToClipboard": "클립보드에 복사되었습니다",
		"eg": "예:",
		"set": "세트",
		"hint": "힌트",
		"itemType": "문항 유형",
		"minute": "분",
		"minutes": "{{count}}분",
		"hour": "시간",
		"hours": "{{count}}시간",
		"continue": "계속",
		"unlock": "잠금 해제",
		"cancel": "취소",
		"view": "보기",
		"switch": "전환",
		"update": "업데이트",
		"ok": "확인",
		"yes": "예",
		"free": "무료",
		"answered": "응답함",
		"correct": "정답",
		"incorrect": "오답",
		"marked": "표시함",
		"unmarked": "표시 안 함",
		"skipped": "건너뜀",
		"skill_one": "능력",
		"skill_other": "능력",
		"word_one": "단어",
		"word_other": "단어",
		"submitResponse": "답안 제출",
		"viewDetails": "세부 정보 보기",
		"sec_one": "초",
		"sec_other": "초",
		"point_one": "점",
		"point_other": "점",
		"week": "주",
		"month": "월",
		"year": "년",
		"day": "일",
		"selectTestDate": "시험일 선택",
		"points": "점수",
		"viewAll": "전체 보기",
		"timeline": "타임라인",
		"save": "저장",
		"filters": {
			"selectAll": "전체 선택",
			"deselectAll": "전체 선택 해제",
			"selectedCount": "{{count}}개 선택됨",
			"expandSection": "{{section}} 펼치기",
			"collapseSection": "{{section}} 접기"
		},
		"showMore": "더 보기",
		"showLess": "간략히 보기",
		"expandA11yLabel": "설명 펼치기",
		"collapseA11yLabel": "설명 접기",
		"done": "완료",
		"clearAll": "모두 지우기",
		"clear": "지우기",
		"datePicker": {
			"title": "날짜 선택",
			"enterDateLabel": "날짜 입력",
			"enterDateRangeLabel": "기간 입력",
			"dateLabel": "날짜",
			"startDateLabel": "시작일",
			"endDateLabel": "종료일",
			"dateRequiredError": "날짜는 필수입니다",
			"invalidDateFormatError": "날짜 형식이 올바르지 않습니다. MM/DD/YYYY 형식을 사용하세요",
			"startAfterEndError": "시작일은 종료일보다 늦을 수 없습니다",
			"endBeforeStartError": "종료일은 시작일보다 빠를 수 없습니다",
			"minDateError": "{{date}} 이후 날짜를 입력하세요",
			"maxDateError": "{{date}} 이전 날짜를 입력하세요",
			"dateRangeError": "{{startDate}}부터 {{endDate}} 사이의 날짜를 입력하세요",
			"setDateCta": "날짜 설정",
			"nextCta": "다음",
			"setTimeCta": "시간 설정"
		}
	},
	"session": {
		"choicePercentageTooltip": "학습자의 {{percentage}}가 이 답을 선택했습니다.",
		"choiceCorrectA11yLabel": "정답",
		"choiceIncorrectA11yLabel": "오답",
		"choiceNotSelectedA11yLabel": "선택되지 않음",
		"moreItemsAlertDialog": {
			"title": "추가 문항",
			"cta": "확인"
		},
		"results": {
			"followUps": {
				"title": "후속 질문"
			},
			"summary": {
				"sessionAnalysis": "세션 분석",
				"itemCount_one": "{{count}}문항",
				"itemCount_other": "{{count}}문항",
				"skilledItemCount_one": "{{skills}} {{count}}문항",
				"skilledItemCount_other": "{{skills}} {{count}}문항",
				"levelPhrase_one": "{{levels}} 수준의",
				"levelPhrase_other": "{{levels}} 수준의",
				"message": "<bold>잘하셨어요!</bold> {{timeTaken}} 만에 {{itemPhrase}}을 완료했습니다.",
				"messageWithLevels": "<bold>잘하셨어요!</bold> {{timeTaken}} 만에 $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) {{itemPhrase}}을 완료했습니다.",
				"proficiencyEstimateReady": "예상 {{skill}} 수준은 <bold>{{currentLevel}}</bold>입니다. 이제 <bold>{{nextLevel}}</bold>에 도전할 준비가 되었습니다.",
				"proficiencyEstimateKeepPracticing": "예상 {{skill}} 수준은 <bold>{{currentLevel}}</bold>입니다. <bold>{{nextLevel}}</bold>(으)로 넘어가기 전에 조금 더 연습해 보세요.",
				"proficiencyEstimateHighest": "예상 {{skill}} 수준은 <bold>{{currentLevel}}</bold>입니다. 정말 훌륭합니다!",
				"mixedLevel": "혼합",
				"overallScore": "종합 점수",
				"stats": {
					"itemsAttempted_one": "푼 문항",
					"itemsAttempted_other": "푼 문항",
					"pointsEarned_one": "획득 점수",
					"pointsEarned_other": "획득 점수",
					"answeredCorrectly": "맞힌 문항",
					"timeTaken": "소요 시간",
					"target": "목표",
					"ofTotal": "/ {{total}}",
					"ofPointsTotal": "/ {{total}}",
					"skill": "능력",
					"skills": "능력",
					"questionType": "문제 유형",
					"questionTypes": "문제 유형",
					"proficiencyLevel": "숙련도 수준",
					"proficiencyLevels": "숙련도 수준"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "{{seconds}}초 후 오디오가 재생됩니다",
			"audioStartsInPlayOnce": "{{seconds}}초 후 오디오가 재생됩니다. 한 번만 재생됩니다",
			"videoStartsIn": "{{seconds}}초 후 영상이 재생됩니다",
			"videoStartsInPlayOnce": "{{seconds}}초 후 영상이 재생됩니다. 한 번만 재생됩니다",
			"recordingIn": "{{seconds}}초 후 녹음이 시작됩니다"
		},
		"timeOverrunBanner": {
			"message": "시간이 종료되었습니다. 실제 시험이라면 이후 답안은 채점되지 않습니다. 연습은 계속할 수 있습니다."
		},
		"attributes": {
			"stimulus": "지문"
		},
		"stimulusTypes": {
			"reading": "읽기",
			"listening": "듣기",
			"speaking": "말하기",
			"writing": "쓰기",
			"image": "이미지"
		},
		"masteryLevels": {
			"belowBasic": "기초 미만",
			"basic": "기초",
			"belowLowIntermediate": "중하급 미만",
			"lowIntermediate": "중하급",
			"highIntermediate": "중상급",
			"advanced": "고급",
			"proficiencySubtitle": "{{trademark}}에서는 **{{minScore}}-{{maxScore}}/30**점에 해당합니다",
			"infoSectionLabel": "{{skill}} 섹션 안내",
			"infoSectionText": {
				"Reading": "{{trademark}} 읽기 섹션은 학술 환경에서 사용되는 지문을 얼마나 잘 읽고 이해하는지를 평가합니다. 각 약 700단어 분량의 지문 2개와 지문당 10문항으로 구성됩니다. 읽기 섹션을 완료하는 데 약 35분이 걸립니다.",
				"Listening": "{{trademark}} 듣기 섹션은 영어로 진행되는 대화와 강의를 이해하는 능력을 측정합니다. 기본적인 내용 이해, 화자의 태도와 확신 정도 파악, 정보 연결하기 등이 포함됩니다. 듣기 섹션을 완료하는 데 약 36분이 걸립니다.",
				"Speaking": "{{trademark}} 말하기 섹션은 학술 환경에서 영어로 효과적으로 말하는 능력을 측정합니다. 4개의 문항/과제는 교실 안팎에서 실제로 마주할 수 있는 상황을 반영합니다. 말하기 섹션을 완료하는 데 약 16분이 걸립니다.",
				"Writing": "{{trademark}} 쓰기 섹션은 학술 환경에서 영어로 글을 쓰고 자신의 생각을 명확하고 체계적으로 전달하는 능력을 측정합니다. 컴퓨터 키보드로 답안을 작성하며, 쓰기 섹션을 완료하는 데 약 29분이 걸립니다."
			}
		},
		"itemTypes": {
			"MCSS": "객관식 단일 선택",
			"MCSSH": "객관식 단일 선택 하이라이트",
			"MCMS": "객관식 복수 선택",
			"MCMSH": "객관식 복수 선택 하이라이트",
			"INSERT_TEXT": "문장 삽입",
			"MATCH_MS": "복수 선택 연결",
			"MCSSM": "객관식 단일 선택 연결",
			"MCMSM": "객관식 복수 선택 연결",
			"MCGS": "객관식 빈칸 선택",
			"MCOS": "객관식 순서 배열",
			"LISTENING_REPLAY": "듣기 다시 재생",
			"AUDIO_INPUT": "음성 입력",
			"ACADEMIC_DISCUSSION_RESPONSE": "학술 토론 답변",
			"INTEGRATED_WRITING_RESPONSE": "통합형 쓰기 답변"
		},
		"passageStem": {
			"itemOfTotal": "{{total}}문항 중 {{current}}번",
			"questionOfTotal": "{{total}}개 질문 중 {{current}}번",
			"stimulusCorrespondsToNextItems": "다음 지문은 이어지는 {{total}}문항에 해당합니다",
			"passage": "지문",
			"lecture": "강의",
			"professorsQuestion": "교수의 질문",
			"listen": "듣기",
			"openPassage": "지문 열기",
			"backToItem": "문항으로 돌아가기",
			"notYetInserted": "아직 삽입되지 않음",
			"insertedAtPosition": "{{position}}번 위치에 삽입됨"
		},
		"hint": {
			"show": "힌트 보기"
		},
		"navigation": {
			"next": "다음",
			"exit": "나가기",
			"saveAndExit": "저장 후 나가기",
			"previous": "이전",
			"skip": "건너뛰기",
			"finish": "완료",
			"help": "도움말",
			"about": "문제 팁",
			"questionsButtonLabel": "문항 탐색",
			"questionsButtonTooltip": "원하는 문항으로 이동하거나 표시한 문항을 검토하세요",
			"questionsButtonActiveFiltersA11y": "적용된 필터: {{count}}개",
			"recordingInProgressTooltip": "녹음이 진행 중일 때는 이 문항에서 이동할 수 없습니다",
			"questionNotReachedTooltip": "아직 이 문항에 도달하지 않았습니다"
		},
		"questionTips": {
			"hideFutureLabel": "팁 자동 표시 안 함"
		},
		"toolbar": {
			"calculatorTooltip": "계산기 열기",
			"highlightTooltip": "중요한 내용을 쉽게 찾을 수 있도록 텍스트를 선택해 강조 표시하세요",
			"markTooltip": "제출 전에 다시 확인할 수 있도록 이 문항을 표시해 두세요",
			"unmarkTooltip": "클릭하면 이 문항의 표시를 해제합니다"
		},
		"summary": {
			"viewFullInsights": "전체 인사이트 보기",
			"targetTooltip": "이 세션의 성취 목표입니다."
		},
		"stats": {
			"skill": "능력",
			"answered": "응답",
			"speed": "속도",
			"duration": "길이",
			"duration_tooltip": "녹음한 답변의 길이: {{duration}}$t(common.sec, {\"count\": {{duration}}})",
			"confidence": "확신도",
			"pointsEarned": "점수",
			"word": "단어",
			"words": "단어",
			"time_taken": "{{time}}{{sec}}",
			"time_taken_tooltip": "이 문항을 읽고 답하는 데 {{time_taken}}$t(common.sec, {\"count\": {{time_taken}}})가 걸렸습니다",
			"skill_tooltip": "이 문항에서 평가하는 능력 영역: {{skill}}",
			"answered_correct_tooltip": "제출한 답이 정답입니다",
			"answered_incorrect_tooltip": "제출한 답이 오답입니다",
			"skipped_tooltip": "이 문항에 답을 제출하지 않았습니다",
			"words_tooltip": "작성한 답변의 단어 수: {{count}}",
			"word_tooltip": "작성한 답변의 단어 수: {{count}}",
			"confidence_tooltip": "답을 제출할 때 얼마나 확신했는지를 나타냅니다",
			"points_earned_tooltip_one": "이 문항에서 최대 {{maximumScore}}점 중 {{points}}점을 획득했습니다",
			"points_earned_tooltip_other": "이 문항에서 최대 {{maximumScore}}점 중 {{points}}점을 획득했습니다",
			"challengers_tooltip": "나보다 먼저 이 문항을 푼 학습자 수: {{count}}",
			"learning_mode_points_tooltip": "이번 시도로 획득한 점수: +{{xp}} XP",
			"pts_earned_tooltip": "이번 시도로 획득한 점수: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "세부 내역 펼치기"
		},
		"explanation": {
			"title": "해설",
			"feedback": "피드백",
			"skippedFeedbackNotice": "이 문항을 건너뛰어 맞춤 피드백이 생성되지 않았습니다."
		},
		"followUps": "후속 질문",
		"suggestCorrection": "수정 제안",
		"answer": {
			"correct": "정답",
			"incorrect": "오답",
			"skipped": "건너뜀"
		},
		"confidence": {
			"high": "높음",
			"medium": "보통",
			"low": "낮음"
		},
		"endDialog": {
			"title": "세션을 지금 끝낼까요?",
			"confirmEndDiagnostic": "세션을 종료하시겠습니까? 모든 진행 상황이 사라지며 처음부터 다시 시작해야 합니다.",
			"confirmEnd": "아직 {{num}} {{itemLabel}}이 남아 있습니다. 지금 끝내거나 계속 학습해 마무리할 수 있습니다.",
			"confirmEndNoAnswer": "아직 아무 문항에도 답하지 않았습니다. 지금 끝내시겠습니까?",
			"confirmEndNoAnswerPositive": "계속 학습하기",
			"confirmEndNoAnswerNegative": "지금 끝내기"
		},
		"permissionDialog": {
			"title": "마이크 권한 필요",
			"descriptionWeb": "말하기 연습에는 마이크가 필요합니다. 브라우저가 이 사이트의 접근을 차단하고 있습니다. 주소창 옆 권한 아이콘을 클릭해 마이크를 허용한 후 다시 시도해 주세요.",
			"descriptionMobile": "말하기 연습에는 마이크가 필요합니다. 계속하려면 기기 설정에서 마이크 접근을 허용해 주세요.",
			"promptDescriptionWeb": "말하기 연습에는 마이크가 필요합니다. 권한을 요청한 뒤 브라우저가 물어보면 '허용'을 선택하세요.",
			"blockedDescriptionWeb": "이 사이트의 마이크 접근이 차단되어 있습니다. 주소창 옆 아이콘을 클릭해 마이크를 허용한 후 권한을 다시 요청해 주세요.",
			"ok": "확인",
			"cancel": "취소",
			"openSettings": "설정 열기",
			"requestPermission": "권한 요청",
			"dismissAndExit": "닫고 나가기",
			"learnMore": "자세히 알아보기"
		},
		"audioPlaybackTestDialog": {
			"title": "오디오 재생 테스트",
			"description": "{{appName}} 앱에는 지문, 시험 문항, 음성 읽어주기 등 여러 오디오 재생 기능이 있습니다. 최적의 환경을 위해 아래에서 오디오를 테스트해 보세요. 정상 작동을 확인한 후 계속 진행하세요.",
			"troubleshooting": {
				"title": "오디오 문제 해결",
				"volumeTitle": "기기 볼륨 확인",
				"volumeDescriptionWeb": "키보드 조작키 또는 메뉴 표시줄/작업 표시줄의 시스템 볼륨 설정으로 볼륨을 조절하세요",
				"volumeDescriptionMobile": "기기의 볼륨 버튼을 사용하거나 시스템 설정에서 조절하세요",
				"outputTitle": "오디오 출력 장치 확인",
				"outputDescription": "헤드폰을 사용한다면 제대로 연결되어 있고 활성 출력 장치로 선택되어 있는지 확인하세요",
				"browserTitle": "브라우저 탭 오디오 확인",
				"browserDescription": "탭 제목 옆에 음소거 스피커 아이콘이 있는지 확인하고, 있다면 음소거를 해제하세요."
			},
			"skipCheck": "다음부터 이 확인 건너뛰기",
			"workingButton": "오디오 확인 완료",
			"textToHear": "다음과 같이 들려야 합니다: {{text}}"
		},
		"overall": "종합",
		"subskills": {
			"content": {
				"title": "내용"
			},
			"languageUse": {
				"title": "언어 사용"
			},
			"organizationAndDevelopment": {
				"title": "구성 및 전개"
			},
			"topicDevelopment": {
				"title": "주제 전개"
			},
			"delivery": {
				"title": "전달력"
			}
		},
		"finalizing": {
			"title": "결과를 정리하는 중",
			"gradingProgress": "답안을 채점하는 중..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "들은 문장을 최대한 정확하게 따라 말하는 말하기 과제입니다.",
			"Read Aloud": "지문을 소리 내어 읽고 평가받는 말하기 문항입니다.",
			"Describe Image": "시각 자료를 자세히 설명하는 말하기 과제입니다.",
			"Write Essay": "주어진 주제에 대해 구조화된 에세이를 작성하는 서술형 과제입니다.",
			"Retell Lecture": "들은 강의나 발표 내용을 요약해 말하는 말하기 과제입니다.",
			"Summarize Group Discussion": "여러 화자가 참여한 토론을 요약하는 듣기 과제입니다.",
			"Answer Short Question": "짧은 질문 하나에 간결하게 답하는 짧은 말하기 과제입니다.",
			"Respond to a Situation": "제시된 상황에 적절하게 응답하는 말하기 과제입니다.",
			"Summarize Written Text": "지문을 자신의 말로 요약하는 읽기 과제입니다.",
			"Reorder Paragraph": "뒤섞인 단락을 올바른 순서로 배열하는 읽기 과제입니다.",
			"Fill in the Blanks (Dropdown)": "각 빈칸을 드롭다운 선택지에서 골라 채우는 읽기 과제입니다.",
			"Fill in the Blanks (Type In)": "빠진 단어나 짧은 구를 입력하는 듣기 과제입니다.",
			"Fill in the Blanks (Drag and Drop)": "선택지를 빈칸으로 끌어다 놓아 빠진 단어를 채우는 읽기 과제입니다.",
			"Multiple Choice, Single Answer": "정답 하나를 선택하는 객관식 문항입니다.",
			"Multiple Choice, Single Answer (Reading)": "정답 하나를 선택하는 읽기 객관식 문항입니다.",
			"Multiple Choice, Single Answer (Listening)": "정답 하나를 선택하는 듣기 객관식 문항입니다.",
			"Multiple Choice, Multiple Answers": "정답을 두 개 이상 선택할 수 있는 문항입니다.",
			"Multiple Choice, Multiple Answers (Reading)": "정답을 두 개 이상 선택할 수 있는 읽기 문항입니다.",
			"Multiple Choice, Multiple Answers (Listening)": "정답을 두 개 이상 선택할 수 있는 듣기 문항입니다.",
			"Summarize Spoken Text": "들은 내용을 요약해 쓰는 듣기 과제입니다.",
			"Highlight Correct Summary": "음성 내용과 가장 잘 맞는 요약을 선택해 표시하는 듣기 과제입니다.",
			"Select Missing Word": "빠진 단어를 고르는 빈칸 채우기 형식의 듣기 과제입니다.",
			"Highlight Incorrect Words": "음성과 다른 스크립트 속 단어를 표시하는 듣기 과제입니다.",
			"Write from Dictation": "들은 문장을 받아쓰는 듣기 과제입니다."
		}
	},
	"report": {
		"readFullInsights": "전체 인사이트 보기",
		"productName": "{{examName}} {{type}}",
		"startedAt": "{{time}}에 시작",
		"itemTypesTitle": "문항 유형별 분석",
		"itemTypesFilterAll": "전체",
		"questionTypeCardTitle": "{{skill}} 문항 유형별 분석",
		"questionTypeCardSubtitle_one": "이번 세션의 {{skill}} 문항 유형 {{count}}개 기준",
		"questionTypeCardSubtitle_other": "이번 세션의 {{skill}} 문항 유형 {{count}}개 기준",
		"questionTypeCardAltSubtitle_one": "이번 세션의 문항 유형 {{count}}개 기준",
		"questionTypeCardAltSubtitle_other": "이번 세션의 문항 유형 {{count}}개 기준",
		"questionTypeRowSubtitle_zero": "완료한 문항 없음",
		"questionTypeRowSubtitle_one": "{{count}}문항 완료",
		"questionTypeRowSubtitle_other": "{{count}}문항 완료",
		"itemTypeDetail": {
			"review_one": "문항 검토",
			"review_other": "문항 검토",
			"stats": {
				"answered_one": "푼 문항",
				"answered_other": "푼 문항",
				"avgTime": "문항당 평균 소요 시간"
			}
		},
		"reviewAnswersDialog": {
			"title": "답안 검토",
			"sections": {
				"skills": "능력",
				"questionTypes": "문제 유형",
				"proficiency": "숙련도",
				"performance": "성취도"
			},
			"summaryNone": "문항이 있는 필터를 선택해 주세요.",
			"summaryAll_one": "전체 답안 {{count}}개를 검토합니다.",
			"summaryAll_other": "전체 답안 {{count}}개를 검토합니다.",
			"summaryFiltered_one": "{{filters}}에 해당하는 답안 {{count}}개를 검토합니다.",
			"summaryFiltered_other": "{{filters}}에 해당하는 답안 {{count}}개를 검토합니다.",
			"reviewAnswers_one": "답안 {{count}}개 검토",
			"reviewAnswers_other": "답안 {{count}}개 검토",
			"more": "외 {{count}}개"
		},
		"itemDetail": {
			"title": "내 답안 검토",
			"filterAll": "전체",
			"filterCorrect": "정답",
			"filterIncorrect": "오답",
			"filterMarked": "표시함",
			"emptyTitle": "일치하는 문항 없음",
			"emptyDescription": "선택한 필터({{filter}})와 일치하는 세션 문항이 없습니다. 필터를 조정하거나 지우고 더 많은 결과를 확인해 보세요.",
			"emptyCta": "필터 지우기"
		},
		"answerCardTitle": "푼 문항",
		"answerCardSubtitle_one": "모든 문항에서의 결과를 확인하세요",
		"answerCardSubtitle_other": "전체 {{count}}문항에서의 결과를 확인하세요",
		"skillsBreakdown": {
			"title": "능력별 분석",
			"subtitle_one": "{{count}}문항 기준",
			"subtitle_other": "{{count}}문항 기준"
		},
		"studyPack": "스터디 팩",
		"practiceTestCompleted": "모의고사 완료",
		"studySessionCompleted": "학습 세션 완료",
		"diagnosticSessionCompleted": "진단 세션 완료",
		"timeElapsed": "경과 시간",
		"stats": {
			"answered": "응답",
			"time elapsed": "경과 시간",
			"avg speed": "평균 속도",
			"hints used": "사용한 힌트"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "훌륭합니다. 지금처럼 최고를 향해 나아가세요!",
				"highIntermediate": "아주 잘하고 있습니다. 강점을 계속 다듬어 보세요!",
				"lowIntermediate": "꾸준히 나아지고 있습니다. 이대로 계속해요!",
				"basic": "실력을 끌어올릴 수 있도록 계속 노력해 보세요!"
			},
			"infoText": "{{skillsText}} {{skills}}을 연습하기 위해 **{{numActivities}} {{activityLabel}}**을 완료했습니다. {{skillDetails}}. 전체적으로 **{{numTotalPoints}}점 중 {{numPointsEarned}}점**을 획득했으며, 이는 {{thisText}} {{skills}} 전반에서 **{{compositeLevel}} 숙련도**에 해당합니다. {{compositeFeedback}}",
			"infoText.singleSkill": "**{{skill_1}}** 능력에 초점을 맞춘 **{{itemCount}} {{itemLabel}}**을 완료했습니다. **{{skill_1_total}}점 중 {{skill_1_score}}점**을 획득했으며, 이는 **{{proficiency}}** 숙련도에 해당합니다. {{compositeFeedback}}",
			"infoText.multiSkill": "**{{skills_text}}** 능력을 연습하며 **{{itemCount}} {{itemLabel}}**을 완료했습니다. {{skill_details}} 전체적으로 **{{overall_total}}점 중 {{overall_score}}점**을 획득했으며, 이는 해당 능력 전반에서 **{{overall_proficiency}}** 숙련도에 해당합니다. {{compositeFeedback}}",
			"skillDetails": "**{{skill}}**에서 **{{total}}점 중 {{score}}점**을 획득해 **{{proficiency}}** 숙련도를 보였습니다."
		},
		"actions": {
			"goToHome": "홈으로 가기",
			"studyMore": "더 학습하기",
			"studyFree": "무료 {{tagTypes}} 학습하기",
			"reviewAnswers": "답안 검토"
		},
		"nextAction": {
			"title": "추천: {{focus}} 연습",
			"dialog": {
				"title": "추천 학습 세션",
				"subtitle": "부족한 영역에 집중하세요"
			},
			"fallback": {
				"title": "계속 연습하기",
				"description": "다음에 보완하고 싶은 영역을 중심으로 학습 세션을 구성해 보세요."
			}
		},
		"premium": {
			"upgradeCta": "프리미엄으로 업그레이드"
		},
		"disclaimer": {
			"title": "유의사항",
			"summativeBody": "모의고사 점수는 추정치이며 실제 {{examName}} 시험에서 동일한 결과를 보장하지 않습니다."
		},
		"performance": {
			"title": "성취도",
			"subtitle": "{{count}}문항 기준",
			"correct": "정답",
			"correctItems": "{{count}}문항",
			"incorrect": "오답",
			"incorrectItems": "{{count}}문항"
		},
		"mastery": {
			"performanceTitle": "성취도",
			"sessionMasteryTitle": "예상 숙련도",
			"subtitle_assessment": "이번 평가의 전체 {{count}} {{item}} 기준",
			"subtitle_session": "이번 세션의 전체 {{count}} {{item}} 기준"
		},
		"sessionAnalysis": {
			"title": "세션 분석",
			"subtitle": "맞춤 분석 및 추천",
			"viewFullAnalysis": "분석 보기",
			"feedbackDialog": {
				"body": "저희는 거의 매일 업데이트하며 더 나은 서비스를 만들기 위해 노력하고 있습니다. 의견을 남겨 주시겠어요?",
				"placeholder": "여기에 의견을 입력하세요",
				"cta": "의견 보내기",
				"successMessage": "의견이 제출되었습니다. 감사합니다!",
				"feedbackLimitError": "의견은 10자 이상이어야 합니다"
			},
			"menuActions": {
				"copy": "복사",
				"altCopy": "요약 텍스트 복사",
				"altPositiveFeedback": "도움이 되었습니다",
				"positiveFeedback": "좋은 답변",
				"negativeFeedback": "아쉬운 답변",
				"reportIssue": "신고",
				"altReportIssue": "이 답변 신고하기",
				"emailSummary": "요약 텍스트 이메일로 보내기",
				"emailAlreadySent": "이미 이메일을 보냈습니다",
				"copiedAnalysis": "분석 내용을 클립보드에 복사했습니다",
				"emailSent": "{{email}}(으)로 이메일을 보냈습니다. 이메일이 오지 않으면 정크, 스팸, 최근 삭제된 항목 폴더를 확인해 주세요",
				"emailFailed": "{{email}}(으)로 이메일을 보내지 못했습니다",
				"emailInstructionMessage": "이메일이 오지 않으면 정크, 스팸, 최근 삭제된 항목 폴더를 확인하거나 IT 관리자에게 문의해 주세요"
			}
		}
	},
	"feedback": {
		"successMessage": "의견이 제출되었습니다. 감사합니다!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "어떤 점이 마음에 드시나요? 어떤 점을 개선하면 좋을까요? 저희는 매일 플랫폼을 개선하고 있으며 모든 의견을 직접 읽고 있습니다. 감사합니다!",
			"title": "의견 보내기",
			"body": "어떤 점이 마음에 드시나요? 어떤 점을 개선하면 좋을까요? 저희는 매일 플랫폼을 개선하고 있으며 모든 의견을 직접 읽고 있습니다. **감사합니다!**",
			"positiveBody": "도움이 되었다니 기쁩니다! **어떤 점이 좋았는지** 알려 주세요.",
			"negativeBody": "**답변을 개선할 수 있도록** 무엇이 잘못되었는지 알려 주세요.",
			"placeholder": "의견 입력",
			"cta": "의견 보내기"
		},
		"report": {
			"title": "신고 제출",
			"body": "이 답변의 어떤 점이 문제인지 알려 주세요",
			"cta": "신고 제출"
		},
		"suggestCorrection": {
			"title": "수정 제안하기",
			"body": "**오류를 알려 주시면** 이 콘텐츠의 정확도를 높이는 데 도움이 됩니다.",
			"cta": "제출"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "부정확함",
					"description": "답변에 잘못된 정보가 포함되어 있습니다"
				},
				"notHelpful": {
					"title": "도움이 안 됨",
					"description": "답변이 제 질문과 맞지 않았습니다"
				},
				"incomplete": {
					"title": "불완전함",
					"description": "답변에 중요한 내용이 빠져 있습니다"
				},
				"hardToUnderstand": {
					"title": "이해하기 어려움",
					"description": "답변이 혼란스럽거나 명확하지 않았습니다"
				},
				"other": {
					"title": "기타",
					"description": "그 밖의 이유"
				}
			},
			"report": {
				"misinformation": {
					"title": "잘못된 정보",
					"description": "답변에 허위이거나 오해를 부르는 정보가 포함되어 있습니다"
				},
				"harmfulContent": {
					"title": "유해하거나 불쾌한 콘텐츠",
					"description": "혐오 표현, 괴롭힘 또는 부적절한 언어"
				},
				"violatesPolicies": {
					"title": "정책 위반",
					"description": "스팸, 자기 홍보 또는 불법 콘텐츠"
				},
				"other": {
					"title": "기타",
					"description": "어떤 점이 문제였는지 직접 작성해 주세요"
				}
			}
		},
		"faqs": {
			"title": "자주 묻는 질문",
			"body": "앱에 대해 가장 자주 묻는 질문을 모았습니다. 다른 궁금한 점이 있다면 support@memorang.ai로 문의해 주세요"
		},
		"delete": {
			"title": "계정 삭제",
			"body": "떠나신다니 아쉽습니다. 앞으로의 학업과 커리어에 행운이 함께하기를 바랍니다!",
			"options": "너무 비쌉니다|이미 시험을 봤습니다|콘텐츠가 마음에 들지 않았습니다|필요한 기능이 없습니다|기타",
			"confirmdelete": {
				"title": "계정 삭제 확인",
				"cta": "삭제",
				"errorMessage": "입력하신 이메일이 이 계정과 일치하지 않습니다. 다시 시도해 주세요",
				"successMessage": "계정이 삭제되었습니다!",
				"validEmail": "유효한 이메일 주소를 입력해 주세요"
			}
		}
	},
	"recorder": {
		"tapToRecord": "탭하여 답변을 녹음하세요",
		"responseAudioUnavailable": "답변 오디오를 재생할 수 없습니다",
		"recording": "녹음 중",
		"recordingCompleted": "녹음 완료",
		"getReady": "준비하세요",
		"timeIsUp": "시간이 종료되었습니다. 답변이 녹음되지 않았습니다.",
		"alert": {
			"title": "최대 길이 도달",
			"body": "최대 길이인 {{maxDuration}}초에 도달해 녹음이 중지되었습니다."
		},
		"uiElementPressed": "녹음이 중지되었습니다 - 녹음 중에 지문이 열렸습니다."
	},
	"writing": {
		"placeholder": "여기에 답변을 작성하세요...",
		"wordCount": "{{count}} {{word}}",
		"title": "내 답변",
		"submit": "제출",
		"helper": {
			"range": "답변을 제출하려면 {{min}}–{{max}}단어로 작성하세요",
			"min": "답변을 제출하려면 최소 {{min}}단어 이상 작성하세요",
			"max": "답변을 {{max}}단어 이하로 줄여 주세요"
		}
	},
	"navbar": {
		"home": "홈",
		"progress": "진행 상황",
		"insights": "인사이트",
		"leaderboard": "순위",
		"store": "스토어",
		"more": "더 보기",
		"redeem": "등록",
		"study-pack": "스터디 팩",
		"podcasts": "팟캐스트",
		"modules": "모듈",
		"account": "계정 설정",
		"accountTab": "계정",
		"privacy": "개인정보",
		"terms": "약관",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "코드를 정확히 입력했는데도 여전히 문제가 있나요? **지원팀에 문의**하고 액세스 코드와 구매 세부 정보를 반드시 포함해 주세요",
		"olxDialog": {
			"unlockedTitle": "액세스 잠금 해제됨",
			"expiredTitle": "액세스 만료됨",
			"testInfo": "**시험:** {{examName}} | **테스트:** {{bundleName}}",
			"upcomingBody_one": "OLX 테스트에 대한 액세스가 잠금 해제되었습니다!\n\n**{{count}}일** 후 세션을 시작할 수 있습니다. 나중에 다시 확인하여 모의고사 탭에서 세션을 시작해 주세요.",
			"upcomingBody_other": "OLX 테스트에 대한 액세스가 잠금 해제되었습니다!\n\n**{{count}}일** 후 세션을 시작할 수 있습니다. 나중에 다시 확인하여 모의고사 탭에서 세션을 시작해 주세요.",
			"activeBody": "OLX 테스트에 대한 액세스가 이제 활성화되었습니다!\n\n**{{date}}** 이전 언제든지 세션을 시작할 수 있습니다.\n\n지금 세션을 시작하시겠습니까, 아니면 나중에 시작하시겠습니까?",
			"expiredBody": "OLX 테스트에 대한 액세스가 **{{date}}**에 만료되었습니다.\n\n추가 지원이 필요하시면 담당 교수 또는 학교 관리자에게 문의해 주세요.",
			"startNowCta": "지금 시작",
			"startLaterCta": "나중에 시작"
		},
		"unexpectedError": "예상치 못한 오류가 발생했습니다."
	},
	"redeemCode": {
		"titleRedeem": "이용 권한 등록",
		"titleGranted": "이용 권한 부여됨",
		"formTitle": "액세스 코드를 입력하세요",
		"accessCodeHint": "액세스 코드가 있다면 하이픈을 포함해 여기에 입력해 주세요.",
		"submit": "등록",
		"access": "여기서 이용하기",
		"helpFindCode": "코드를 찾는 데 도움이 필요하신가요?",
		"troubleRedeeming": "등록에 문제가 있나요? 어시스턴트에게 물어보세요!",
		"skipStep": "이 단계 건너뛰기"
	},
	"autoRedeem": {
		"redeem": "등록",
		"redeeming": "등록 중...",
		"continue": "계속",
		"unredeemedPrompt_one": "이메일 주소 **{{email}}**에 연결된 상품 중 아직 등록되지 않은 **상품 {{count}}개**가 있습니다. 계정에 추가하시겠습니까?",
		"unredeemedPrompt_other": "이메일 주소 **{{email}}**에 연결된 상품 중 아직 등록되지 않은 **상품 {{count}}개**가 있습니다. 계정에 추가하시겠습니까?",
		"successMessage_one": "축하합니다! 아래 **상품**이 계정에 등록되었습니다. 계속을 누르면 앱의 컨텍스트가 **{{examName}}** 시험에 맞게 변경됩니다. 다른 시험을 준비하거나 다른 상품을 구매하려는 경우 계정 설정에서 언제든지 변경할 수 있습니다.",
		"successMessage_other": "축하합니다! 아래 **상품 {{count}}개**가 계정에 등록되었습니다. 계속을 누르면 앱의 컨텍스트가 **{{examName}}** 시험에 맞게 변경됩니다. 다른 시험을 준비하거나 다른 상품을 구매하려는 경우 계정 설정에서 언제든지 변경할 수 있습니다."
	},
	"olxEligibility": {
		"goToPracticeTests": "모의고사로 이동"
	},
	"moreChallenges": {
		"challenges": "챌린지",
		"challengesCount": "챌린지 {{value}}개"
	},
	"tts": {
		"tooltip": "듣기"
	},
	"commandBar": {
		"placeholder": "검색...",
		"input": {
			"placeholder": "명령어를 입력하거나 검색하세요"
		},
		"sections": {
			"quickActions": "빠른 작업"
		},
		"actions": {
			"changeExam": "시험 변경",
			"switchToDarkMode": "다크 모드로 전환",
			"switchToLightMode": "라이트 모드로 전환",
			"setExamDate": "시험일 설정"
		}
	},
	"filterView": {
		"placeholder": "시험 검색..."
	},
	"transcript": {
		"show": "스크립트 보기",
		"hide": "스크립트 숨기기"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "앱 로고",
			"testNameLabel": "시험 이름",
			"sectionLabel": "섹션",
			"back": "돌아가기",
			"pause": "일시 정지",
			"menuLabel": "옵션 더 보기"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "시험 진행 상황",
			"of": "/",
			"pauseSession": "세션 일시 정지",
			"timerTooltip": {
				"item": "이 문항의 남은 시간",
				"section": "이 섹션의 남은 시간",
				"test": "이 시험의 남은 시간"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "다음"
		},
		"progressBar": {
			"timeLeftLabel": "이 문항의 남은 시간",
			"timeLeftForUnit": "이 단원의 남은 시간",
			"questionOf": "{{total}}문항 중 {{current}}번",
			"questionProgress": "<b>{{current}}</b>/{{total}}",
			"timesUp": "시간 종료",
			"statusTooltips": {
				"answered": "응답함",
				"inProgress": "진행 중",
				"skipped": "건너뜀",
				"notSeen": "미확인"
			}
		},
		"timeRemainingDialog": {
			"title": "아직 시간이 남아 있습니다",
			"body": "이 단원에 시간이 아직 남아 있습니다. 제출하기 전에 답안을 검토하시겠습니까?",
			"reviewCta": "내 답안 검토"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "원문",
				"answerTitle": "내 답안",
				"remainingBadge": "{{count}}개 남음",
				"placedBadge": "{{count}}개 배치함",
				"pointsBadge": "{{earned}}/{{max}}점",
				"emptyHint": "왼쪽 패널에서 문단을 여기로 끌어다 놓으세요"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "고객 지원 정보",
			"emailLabel": "이메일",
			"subjectLabel": "제목",
			"messageBodyLabel": "메시지 내용",
			"appDetailsLabel": "앱 정보",
			"appNameLabel": "이름",
			"versionLabel": "버전",
			"platformLabel": "플랫폼"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} 지원 어시스턴트",
			"fallbackTitle": "채팅",
			"betaWarning": "이 AI 어시스턴트는 **베타** 버전입니다—응답이 가끔 부정확하거나 불완전할 수 있습니다.",
			"greeting": "안녕하세요 👋 제품 액세스에 문제가 있으신가요? 제가 도와드리겠습니다! 먼저 문제를 좁혀보겠습니다. 다음 중 귀하의 상황을 가장 잘 설명하는 것은 무엇인가요?\n\n1. 액세스 코드는 있지만 작동하지 않는 것 같습니다.\n2. 구매는 했지만 액세스 코드를 찾을 수 없습니다.\n3. 학교를 통해 액세스 권한을 받았어야 하지만 액세스 코드를 찾을 수 없습니다.\n4. 이전에는 제품에 액세스할 수 있었지만 현재는 액세스할 수 없습니다.\n\n문제에 해당하는 번호를 입력해 주세요.",
			"input": {
				"label": "메시지를 입력하세요...",
				"sendLabel": "보내기"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 등록 완료",
			"previouslyRedeemedTitle": "🚀 이전에 등록됨",
			"subtitle": "여기에서 콘텐츠에 액세스하세요",
			"expires": "만료: {{date}}",
			"openCta": "열기"
		},
		"purchases": {
			"title": "🎉 액세스 코드를 찾았습니다",
			"subtitle": "등록하여 콘텐츠에 액세스하세요",
			"accessCodesLabel_one": "액세스 코드",
			"accessCodesLabel_other": "액세스 코드",
			"moreCodes_one": "(+ {{count}}개 더)",
			"moreCodes_other": "(+ {{count}}개 더)",
			"featuresLabel": "기능",
			"redeemCta": "등록"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "새 버전이 있습니다. 새로 고침을 눌러 업데이트하세요.",
			"refreshCta": "새로 고침",
			"refreshA11yLabel": "새로 고쳐 앱 업데이트",
			"dismissTooltip": "닫기",
			"dismissA11yLabel": "업데이트 알림 닫기"
		}
	},
	"cme": {
		"type": "CME 유형",
		"chooseExportMethod": "내보내기 방법 선택",
		"selectDateRange": "날짜 범위 선택",
		"from": "시작",
		"to": "종료",
		"sendPdfTo": "PDF를 {{email}}로 전송",
		"downloadCertificate": "인증서를 PDF로 다운로드",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "CME 크레딧 획득됨",
		"confirmYourName": "이름 확인",
		"certificateNameNotice": "이 이름이 CME 인증서에 인쇄됩니다.",
		"firstName": "이름",
		"lastName": "성",
		"firstNamePlaceholder": "이름을 입력하세요",
		"lastNamePlaceholder": "성을 입력하세요",
		"confirm": "확인",
		"creditsEarnedTitle": "CME 획득됨",
		"creditRatioCaption": "12개 챌린지 = 1 CME 크레딧",
		"earned": "획득됨",
		"available": "사용 가능",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "CME 인증서 내보내기",
		"exportDisabledCaption": "인증서를 내보내려면 최소 1개의 CME 크레딧을 획득해야 합니다",
		"viewDisclaimer": "CME 면책조항 보기"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "설명",
			"tagsHeading": "태그",
			"citationsHeading": "인용 문헌",
			"playing": "재생 중"
		},
		"a11y": {
			"artwork": "{{title}} 아트워크",
			"playEpisode": "에피소드 재생, {{duration}}",
			"pauseEpisode": "에피소드 일시정지",
			"play": "재생",
			"pause": "일시정지",
			"addToQueue": "대기열에 추가",
			"removeFromQueue": "대기열에서 제거",
			"addBookmark": "북마크",
			"removeBookmark": "북마크 해제",
			"seekBar": "탐색 바",
			"skipPrevious": "이전 트랙으로 이동",
			"skipNext": "다음 트랙으로 이동",
			"rewind": "{{seconds}}초 뒤로",
			"fastForward": "{{seconds}}초 앞으로",
			"playbackSpeed": "재생 속도 {{speed}}x"
		}
	}
}
